export default {"src":"/_next/static/media/female_6.7dbb112f.svg","height":144,"width":145,"blurWidth":0,"blurHeight":0};